import { render, staticRenderFns } from "./examinetopic-form.vue?vue&type=template&id=9e909d4c&"
import script from "./examinetopic-form.vue?vue&type=script&lang=js&"
export * from "./examinetopic-form.vue?vue&type=script&lang=js&"
import style0 from "./examinetopic-form.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports